import {useEffect, useState} from "react";
import {Context} from "./component/Context";
import SubmitMetaData from "./component/SubmitMetaData";
import SubmitOptions from "./component/SubmitOptions";
import axios from "axios";
import {createQuestionPath, createSelectionPath, restUrl} from "../../../../../apiUrl";
import {useLocation, useNavigate} from "react-router-dom";

export default function CreatePrompt(){
    const [file, setFile] = useState(null)
    const [original, setOriginal] = useState("")
    const [answer, setAnswer] = useState("")
    const [step3Text,setStep3Text] = useState("")
    const [step3Desc,setStep3Desc] = useState("")
    
    const [metaData, setMetaData] = useState({
        ai:[],
        max:"",
        allowedPrompting:"",
        words:"",
        summary:"",
        memo:"",
    })
    const [question, setQuestion] = useState({
        step1:{label:"1단계", title:"", options:[{title:'', type: '', selection: []}, {title:'', type:'', value:''}],},
        step2:{label:"2단계", title:"", options:[]},
    })

    useEffect(() => {
        init()
    }, []);

    const {state} = useLocation()
    const init = async () => {
        const steps = {}
        const {data} = await axios.get(`${restUrl}/activity_test_problem_view_prompt_create?test_id=eq.${state.testId}`)
        setAnswer(data.filter(it=>it.type==='prompt')[0].answer)
        for (let i = 1; i < 10; i++) {
            const iStep = data.filter(it=>it.difficulty_id === i)
            if (iStep.length === 0) continue
            steps[`step${i}`] = {
                label: `${i}단계`, title: '', options: iStep.map(it => {
                    const re = {}
                    re.id = it.id
                    re.test_id = it.test_id
                    re.difficulty_id = it.difficulty_id
                    re.type_id = it.type_id
                    re.title = it.problem
                    re.type = it.type
                    if (it.selections !== null) re.selection = it.selections
                    return re
                })
            }
            for (const step of iStep) {
                if (step.type_id === 10) {
                    steps[`step${i}`] = {...steps[`step${i}`], desc: step.problem}
                }
            }
        }
        for (const stepsKey of Object.keys(steps)) {
            steps[stepsKey].options.sort((a, b) => b.type_id - a.type_id)
        }
        setQuestion(steps)
        const res = await axios.get(`${restUrl}/activity_test_metadata_prompt?test_id=eq.${state.testId}`)
        const ai = res.data[0].ai
        const questions = res.data[0].questions
        const m = {...metaData}
        m.allowedPrompting = questions
        m.ai = JSON.parse(ai)
        setMetaData(m)
    }

    useEffect(() => {
        console.log(question)
    }, [question]);

    const save = async () => {
        await axios.patch(`${restUrl}/activity_test_instance?id=eq.${state.testId}`, {summary: metaData.summary})
        await axios.post(`${restUrl}/rpc/update_test_problem_answers`, {p_test_id:state.testId, p_new_answer_value:answer})
        for (const items of Object.values(question)) {
            for (const item of items.options) {
                await axios.patch(`${restUrl}/${createQuestionPath}?id=eq.${item.id}`, {problem: item.title})
                if (item.hasOwnProperty('selection')) { //단답형
                    const selectionId = await axios.get(`${restUrl}/${createSelectionPath}?select=id.min()&problem_id=eq.${item.id}`)
                    for (const [index, value] of item["selection"].entries()) {
                        const selection = {
                            problem_id: item.id,
                            selection: value
                        };
                        await axios.patch(`${restUrl}/${createSelectionPath}?id=eq.${selectionId.data[0].min + index}`, selection)
                    }
                }
            }
        }

    }

    const nav = useNavigate()
    return(
        <Context.Provider value={{
            file, setFile, original, setOriginal, answer, setAnswer,
            metaData, setMetaData, question, setQuestion,setStep3Text,step3Desc,step3Text,setStep3Desc
        }}>
            <SubmitMetaData testId={state.testId}/>
            <SubmitOptions/>
            {/*<Step3/>*/}
            <section></section>
            <button className={`w-full py-4 bg-slate-900 text-white font-bold`}
            onClick={async()=>{
                await save()
                alert("출제됐습니다")
                nav(-1)
            }}>출제하기</button>
        </Context.Provider>
    )
}

// const add = async ()=>{
//     const maxResponse = await axios.get(`${restUrl}/${maxPath}`);
//     const maxNum = maxResponse.data[0].max;
//     const problemArray = []
//     const selectionArray = []
//
//
//     let idx = 0;
//     Object.keys(question).forEach((e,i) => {
//         question[e].options.forEach((prob)=>{
//             idx += 1;
//             problemArray.push({
//                 id : maxNum +idx,
//                 problem : prob["title"],
//                 test_id: state.testId,
//                 category_id:3,
//                 difficulty_id : e.slice(-1),
//                 score : 0,
//                 type_id : typeIdMap[prob["type"]]
//             });
//
//             if(prob["selection"]){
//                 prob["selection"].forEach(item => {
//                     selectionArray.push({
//                         problem_id:maxNum +idx,
//                         selection : item
//                     })
//                 })
//             }else {
//                 selectionArray.push({
//                     problem_id:maxNum +idx,
//                     selection : prob["value"]
//                 })
//             }
//         })
//     })
//     // const step3Id= maxNum+ problemArray.length+1;
//     // problemArray.push({
//     //     id : step3Id,
//     //     problem : step3Text,
//     //     test_id:testId,
//     //     category_id:3,
//     //     difficulty_id :  3,
//     //     score : 0,
//     //     type_id : 8
//     // });
//     // selectionArray.push({
//     //     problem_id:step3Id,
//     //     selection : step3Desc
//     // })
//
//     const lastLength = problemArray.length+1;
//     for(let i = 0; i < metaData.allowedPrompting;i++) {
//         console.log(i)
//         problemArray.push({
//             id : maxNum +lastLength+ i,
//             problem : "",
//             test_id:state.testId,
//             category_id:3,
//             difficulty_id :  0,
//             score : 0,
//             type_id : 9
//         });
//     }
//     console.log(problemArray)
//     console.log(selectionArray)
//     await axios.post(`${restUrl}/${createQuestionPath}`,problemArray)
//     await axios.post(`${restUrl}/${createSelectionPath}`,selectionArray)
// }